
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mui-x-v5",
      function () {
        return require("private-next-pages/blog/mui-x-v5.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/mui-x-v5"])
      });
    }
  